"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.INCREMENT = exports.FAILURE = exports.SUCCESS = exports.REQUEST = exports.SAGA = void 0;
var SAGA = 'apiFlow/filterOptions/SAGA';
exports.SAGA = SAGA;
var REQUEST = 'apiFlow/filterOptions/REQUEST';
exports.REQUEST = REQUEST;
var SUCCESS = 'apiFlow/filterOptions/SUCCESS';
exports.SUCCESS = SUCCESS;
var FAILURE = 'apiFlow/filterOptions/FAILURE';
exports.FAILURE = FAILURE;
var INCREMENT = 'apiFlow/filterOptions/INCREMENT';
exports.INCREMENT = INCREMENT;